import $ from "jquery"

import MMap from './MMap'

export const initMaps = () => {  
  $(".m-map").each( initMap );
}

const initMap = (index, el) => {
  let $map = $(el);
  let id = $map.attr("id");
  let mapDataSelector = $map.data("map-data");
  let $mapData = $(mapDataSelector);
  if (!$map || !id || !mapDataSelector || !$mapData.length) {
    console.log("map init failed", index, el);
    return false
  }
  let mmap = new MMap({$map, id, $mapData});
}